import Script from 'next/script';

export default function TrustPilot() {
  return (
    <>
      <Script src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" />
      <div
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id="5406e65db0d04a09e042d5fc"
        data-businessunit-id="57dff8180000ff000594e8bb"
        data-style-height="28px"
        data-style-width="100%"
      >
        <a
          href="https://www.trustpilot.com/review/pivothealth.com"
          target="_blank"
          rel="noopener"
        >
          Trustpilot
        </a>
      </div>
    </>
  );
}
